var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "订单维护",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.initloading,
                  expression: "initloading",
                },
              ],
              ref: "pram",
              attrs: { "label-width": "100px", model: _vm.pram },
            },
            [
              _c("el-form-item", { attrs: { label: "订单编号：" } }, [
                _vm._v(_vm._s(_vm.orderDetail.orderNo)),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "维护状态：",
                    prop: "status",
                    rules: [
                      {
                        required: true,
                        message: "请选择维护状态",
                        trigger: ["change"],
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { clearable: "", placeholder: "请选择" },
                      model: {
                        value: _vm.pram.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "status", $$v)
                        },
                        expression: "pram.status",
                      },
                    },
                    _vm._l(_vm.handerOptions, function (item) {
                      return _c("el-option", {
                        key: item.value,
                        attrs: { label: item.name, value: item.value },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "流水号：", prop: "supplierNo" } },
                [
                  _c("el-input", {
                    attrs: { clearable: "", placeholder: "流水号" },
                    model: {
                      value: _vm.pram.supplierNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "supplierNo", $$v)
                      },
                      expression: "pram.supplierNo",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: { click: _vm.handerSubmit },
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }